import api from "src/features/auth/axiosConfig";
import { errorHandling } from "./errorHandling";
import { AxiosRequestConfig } from "axios";
import { CreditControlSettings } from "../configurations/creditControl/types";

const BackendVersion = "v2";

const shoppingCart = `/app/pos/${BackendVersion}/shopping_cart`;
const category = `/app/pos/${BackendVersion}/category`;
const product = `/app/pos/${BackendVersion}/product`;
const customer = `/app/pos/${BackendVersion}/customer`;
const staff = `/app/pos/${BackendVersion}/staff`;
const ledger = `/pos/${BackendVersion}/ledger`;
const ledgerCustomer = `/pos/${BackendVersion}/ledger/customer`;
const order = `/app/pos/${BackendVersion}/order`;
const cancelOrder = `/app/pos/${BackendVersion}/cancel_order?orderid=`;
const orderReturn = `/app/pos/${BackendVersion}/order_reverse`;
const dashboard = `/app/pos/${BackendVersion}/dashboard`;
const profile = `/pos/${BackendVersion}/profile`;
const user = `/pos/${BackendVersion}/user_details`;
const cardpaymetOrder = `/app/pos/${BackendVersion}/razorpay/create-order`;
const verifyPaymentEndpoint = `/app/pos/${BackendVersion}/razorpay/verify-payment`;
const razerpayConfig = `/app/pos/${BackendVersion}/payment/config`;
const summaryReportApi = `/app/pos/v2/summary_report`;
const customerSummaryApi = `/pos/${BackendVersion}/ledger/customer`;
const creditControlSettings = `/app/pos/${BackendVersion}/credit-control`;
const draftOrder = `/app/pos/${BackendVersion}/draft-order`;
const inventoryCheck = `/app/pos/${BackendVersion}/auth-inventory`;

export const getShoppingCart = async (id: string | number) => {
  try {
    const responce = await api.get(`${shoppingCart}/${id}`);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const postShoppingCart = async (data: any) => {
  try {
    const responce = await api.post(`${shoppingCart}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const putShoppingCart = async (id: string | number, data: any, config?: AxiosRequestConfig) => {
  try {
    const responce = await api.put(`${shoppingCart}/${id}`, data, config);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const deleteShoppingCart = async (id: string | number) => {
  try {
    const response = await api.delete(`${shoppingCart}/${id}`);
    return response;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const getCategory = async (data?: boolean, page?: number, row?: number, search?: string, sortField?: string, order?: string) => {
  try {
    const responce = await api.get(
      `${category}?include_deleted=${data || false}&pageNumber=${page || 1}&pageSize=${row || ""}&searchBy=${search || ""}&sortField=${sortField || ""}&sortOrder=${order || ""}`,
    );
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const postCategory = async (data: any) => {
  try {
    const responce = await api.post(`${category}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const getCategoryAll = async () => {
  try {
    const responce = await api.get(`${category}?include_deleted=false&pageNumber=&pageSize=`);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const deleteCategory = async (ids: (string | number)[]) => {
  try {
    const response = await api.delete(`${category}`, { data: { ids } });
    return response;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const getSingleCategory = async (id: string | number) => {
  try {
    const responce = await api.get(`${category}/${id}`);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const putCategory = async (id: string | number, data: any) => {
  try {
    const responce = await api.put(`${category}/${id}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const patchCategory = async (id: string | number, data: any) => {
  try {
    const responce = await api.patch(`${category}/${id}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const updateCategory = async (id: string | number, data: any) => {
  try {
    const responce = await api.patch(`${category}/${id}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const getProduct = async (data?: boolean, page?: number, row?: number, search?: string, categoryid?: string, sortField?: string, order?: string) => {
  try {
    const responce = await api.get(
      `${product}?include_deleted=${data || "false"}&pageNumber=${page || ""}&pageSize=${row || ""}&searchBy=${search || ""}&category_id=${categoryid || ""}&sortField=${sortField || ""}&sortOrder=${order || ""
      }`,
    );
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const postProduct = async (data: any) => {
  try {
    const responce = await api.post(`${product}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const patchProduct = async (id: string | number, data: any) => {
  try {
    const responce = await api.patch(`${product}/${id}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const putProduct = async (id: string | number, data: FormData, config?: AxiosRequestConfig) => {
  try {
    const responce = await api.put(`${product}/${id}`, data, config);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const deleteProducts = async (ids: (string | number)[]) => {
  try {
    const response = await api.delete(`${product}`, { data: { ids } });
    return response;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const getCustomer = async (data?: boolean, page?: number, row?: number, search?: string, sortField?: string, order?: string) => {
  try {
    const responce = await api.get(
      `${customer}?include_deleted=${data || "false"}&pageNumber=${page || ""}&pageSize=${row || ""}&searchBy=${search || ""}&sortField=${sortField || ""}&sortOrder=${order || ""}`,
    );
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const postCustomer = async (data: any) => {
  try {
    const responce = await api.post(`${customer}`, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const patchCustomer = async (id: string | number, data: any) => {
  try {
    const responce = await api.patch(`${customer}/${id}`, data);
    return responce;
  } catch (error) {
    // errorHandling(error);
    throw error;
  }
};

export const putCustomer = async (id: string | number, data: any) => {
  try {
    const responce = await api.put(`${customer}/${id}`, data);
    return responce;
  } catch (error) {
    // errorHandling(error);
    throw error;
  }
};

export const deleteCustomers = async (ids: (string | number)[]) => {
  try {
    const response = await api.delete(`${customer}`, { data: { ids } });
    return response;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const getStaff = async (data?: boolean) => {
  try {
    const responce = await api.get(`${staff}?include_deleted=${data || false}`);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const getLedger = async (page?: number, row?: number, search?: string, sortField?: string, order?: string, includeSettled?: boolean) => {
  try {
    const response = await api.get(
      `${ledger}?pageNumber=${page || 1}&pageSize=${row || ""}&searchBy=${search || ""}&sortField=${sortField || ""}&sortOrder=${order || ""}&includeSettled=${includeSettled || false}`,
    );
    return response;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const getLedgerByCustomer = async (customerid: string, page?: number, row?: number, includeHistory?: boolean, sortField?: string, sortOrder?: string) => {
  try {
    const responce = await api.get(
      `${ledgerCustomer}/${customerid}?pageNumber=${page || 1}&pageSize=${row || 10}&includeHistory=${includeHistory || false}&sortField=${sortField || "orderedOn"}&sortOrder=${sortOrder || "desc"}`,
    );
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const putLedgerByCustomer = async (customerId: string, data: any) => {
  try {
    const responce = await api.put(`${ledgerCustomer}/${customerId}`, data);
    return responce;
  } catch (error) {
    // errorHandling(error);
    throw error;
  }
};

export const postLedger = async (data: any) => {
  try {
    const responce = await api.post(`${ledger}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const patchLedger = async (customerid: string, data: any) => {
  try {
    const responce = await api.patch(`${ledger}/${customerid}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};
export const putLedger = async (customerid: string, data: any) => {
  try {
    const responce = await api.put(`${ledger}/${customerid}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const getOrder = async (
  id?: string,
  page?: number,
  limit?: number,
  startDate?: string,
  endDate?: string,
  name?: string,
  staff?: string,
  sortField?: string,
  status?: string,
  params?: Record<string, any>,
) => {
  try {
    const response = await api.get(id ? `${order}/${id}` : order, {
      params: {
        pageNumber: page || 1,
        pageSize: limit || "",
        startDate: startDate || "",
        endDate: endDate || "",
        customer_name: name || "",
        staffId: staff || "",
        sortField: sortField || "",
        sortOrder: "desc",
        status: status || "",

        // 🔥 extra dynamic filters (dateFilter, searchBy, startDate, endDate, etc.)
        ...(params || {}),
      },
    });

    return response;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const postOrder = async (data: any) => {
  try {
    const responce = await api.post(`${order}`, data);
    return responce;
  } catch (error) {
    // errorHandling(error);
    throw error;
  }
};

export const patchOrder = async (orderId: string, data: any) => {
  try {
    const responce = await api.patch(`${order}/${orderId}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const putOrder = async (orderId: string, data: any) => {
  try {
    const responce = await api.put(`${order}/${orderId}`, data);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const deleteOrder = async (orderId: string) => {
  try {
    const responce = await api.delete(`${order}/${orderId}`);
    return responce;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const putCancelOrder = async (orderId: string | undefined, payload?: any) => {
  try {
    const response = await api.put(`${cancelOrder}${orderId}`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    errorHandling(error);
    throw error;
  }
};

export const orderReturnId = async (id: string, data: any) => {
  const url = `${orderReturn}/${id}`;
  try {
    const responce = await api.put(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const orderLedger = async (id: string) => {
  const url = `${order}?order_object_id=${id}`;
  try {
    const responce = await api.get(url);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const dashBoard = async (From?: string, to?: string, year?: string) => {
  const url = From && to ? `${dashboard}?start_date=${From}&end_date=${to}&year=${year}` : dashboard;
  try {
    const responce = await api.get(url);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putProfile = async (file: any, Id: string) => {
  try {
    const responce = await api.put(`${profile}/${Id}`, file);
    return responce;
  } catch (error) {
    throw error;
  }
};

// Update the getUser function to accept an optional ID
export const getUser = async (id?: string) => {
  try {
    // If ID is provided, fetch specific user, otherwise fetch all users
    const url = id ? `${user}/${id}` : user;
    const response = await api.get(url);
    return response;
  } catch (error) {
    throw error;
  }
};
interface RazorpayOrderResponse {
  key: string;
  amount: number;
  currency: string;
  order_id: string;
}

export const cardPayment = async (data: any): Promise<RazorpayOrderResponse> => {
  try {
    const response = await api.post<RazorpayOrderResponse>(`${cardpaymetOrder}`, data);
    return response.data; // unwrap Axios envelope
  } catch (error) {
    throw error;
  }
};

interface RazorpayHandlerResponse {
  payment: any;
  valid: any;
  razorpay_order_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}

export const verifyPayment = async (data: any): Promise<RazorpayHandlerResponse> => {
  try {
    const response = await api.post<RazorpayHandlerResponse>(verifyPaymentEndpoint, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const razerPayUpdate = async (data: any) => {
  try {
    const response = await api.post(razerpayConfig, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const razerPayGet = async () => {
  try {
    const response = await api.get(razerpayConfig);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const summeryReport = async (from: string, to: string, userId?: string) => {
  const dateFormate = `startDate=${from}&endDate=${to}`;
  const userIdParam = userId ? `&userId=${userId}` : "";
  try {
    const response = await api.get(`${summaryReportApi}?${dateFormate}${userIdParam}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const customerSummary = async (customerId: string, from: string, to: string) => {
  try {
    const response = await api.get(`${customerSummaryApi}/${customerId}`, { params: { dateFilter: "custom", startDate: from, endDate: to } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCreditControlSettings = async () => {
  try {
    const response = await api.get(creditControlSettings);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCreditControlSettings = async (data: CreditControlSettings) => {
  try {
    const response = await api.put(creditControlSettings, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postCreditApprovalRequest = async (draftId: String, data: any) => {
  const url = `${draftOrder}/${draftId}`;
  try {
    const response = await api.post(url, { receiverEmail: data });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOrderDraft = async (id?: string, approvalStatus?: string, searchBy?: string) => {
  const params = new URLSearchParams();

  if (approvalStatus) {
    params.append("approvalStatus", approvalStatus);
  }

  if (searchBy) {
    params.append("searchBy", searchBy);
  }

  const queryString = params.toString();
  const url = id ? `${draftOrder}/${id}` : queryString ? `${draftOrder}?${queryString}` : `${draftOrder}`;

  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const putOrderDraft = async (id: string, data: any) => {
  const url = id ? `${draftOrder}/${id}` : `${draftOrder}`;

  try {
    const response = await api.put(url, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkInventory = async () => {
  try {
    const response = await api.get(inventoryCheck);
    return response.data;
  } catch (error) {
    throw error;
  }
};
